var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStationListIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: #f2f5f9;\n      }\n\n      .cls-3 {\n        fill: #34384b;\n        stroke: #34384b;\n        stroke-width: .2px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9681",
    "data-name": "Group 9681"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6557",
    "data-name": "Rectangle 6557",
    className: "cls-2",
    width: 24,
    height: 24,
    rx: 4,
    ry: 4
  }), /*#__PURE__*/React.createElement("g", {
    id: "outline-trending_up-24px",
    "data-name": "outline-trending up-24px"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_192",
    "data-name": "Path 192",
    className: "cls-1",
    d: "m2,2h20v20H2V2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "local_gas_station_FILL0_wght400_GRAD0_opsz48",
    "data-name": "local gas station FILL0 wght400 GRAD0 opsz48",
    className: "cls-3",
    d: "m5,19.82V5.7c.02-.7.58-1.27,1.28-1.28h5.76c.7.02,1.27.58,1.28,1.28v6.16h1.39c.59,0,1.07.48,1.07,1.07v4.68c0,.29.11.58.33.78.45.42,1.15.42,1.6,0,.22-.2.34-.48.33-.78v-6.31c-.16.09-.32.15-.49.19-.17.04-.34.06-.51.06-1.1.01-2-.87-2.01-1.97,0-.01,0-.03,0-.04,0-.44.13-.86.38-1.21.25-.35.61-.6,1.03-.71l-2.03-2.03.77-.75,3.27,3.27c.19.19.36.41.48.65.12.24.19.51.18.78v8.06c0,1.22-.99,2.2-2.2,2.2s-2.2-.99-2.2-2.2v-4.69h-1.39v6.89H5Zm1.28-9.24h5.76v-4.88h-5.76v4.88Zm10.76-.09c.52,0,.95-.42.96-.94,0-.52-.42-.95-.94-.96-.52,0-.95.42-.96.94,0,.26.1.5.28.68.17.18.41.28.66.28h0Zm-10.76,8.04h5.76v-6.68h-5.76v6.68Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStationListIcon);
export default __webpack_public_path__ + "static/media/station-list-icon.9009ecd11b67ff959556899547298491.svg";
export { ForwardRef as ReactComponent };